//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as systemAdminApi from '@/api/systemadmin.js';
import { getInfo } from '@/api/user.js';
import Cookies from 'js-cookie';
import { Debounce } from '@/utils/validate';
export default {
  name: 'index',
  data: function data() {
    var JavaInfo = JSON.parse(Cookies.get('JavaInfo'));
    return {
      JavaInfo: JSON.parse(Cookies.get('JavaInfo')),
      pram: {
        account: JavaInfo.account,
        realName: JavaInfo.realName,
        id: JavaInfo.id
      },
      roleList: [],
      rules: {
        account: [{
          required: true,
          message: '请填管理员账号',
          trigger: ['blur', 'change']
        }],
        realName: [{
          required: true,
          message: '请填管理员姓名',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    close: function close(formName) {
      this.$refs[formName].resetFields();
    },
    handlerSubmit: Debounce(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          systemAdminApi.adminNameUpdateApi({
            realName: _this.pram.realName
          }).then(function (data) {
            _this.$message.success('提交成功');
            _this.$router.go(-1);
          });
        } else {
          return false;
        }
      });
    })
  }
};